<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      :customSub="true"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        oilCardTypeOptions: [],
        operationTypeOptions: [],
        oilCardStatusOptions: [],
        cardTypeOptions: [],
        form: [
          { // 主卡类型
            label: '油卡类型',
            value: 'oilCardType',
            type: 'select',
            default: -1,
            placeholder: '请输入主卡类型',
          },
          { // 子卡卡号
            label: '子卡卡号',
            value: 'oilCardNum',
            type: 'input',
            placeholder: '请输入子卡卡号',
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          // { // 子卡状态
          //   label: '子卡状态',
          //   value: 'oilCardStatus',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请输入子卡状态',
          // },
          { // 服务商
            label: '服务商',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入服务商',
          },
          { // 来源类型
            label: '来源类型',
            value: 'cardType',
            type: 'select',
            default: -1,
            placeholder: '请输入来源类型',
          },
          { // 操作类型
            label: '操作类型',
            value: 'operationType',
            type: 'select',
            default: -1,
            placeholder: '请输入操作类型',
            options: [
              { label: '全部', value: -1 },
              { label: '分配', value: 1 },
              { label: '充值', value: 2 },
            ],
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      const oilCardNum = this.$route.query.oilCardNum;
      if (oilCardNum) {
        this.$refs.searchBox.setVal('oilCardNum', oilCardNum);
        searchBoxData.oilCardNum = oilCardNum;
      }
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        ...searchBoxData,
      });
    },
    async getEnumList () {
      const enumList = await getEnumList({
        codeType: 'SERV_OIL_CARD_TYPE,OIL_CARD_TYPE,OILCARD_STATUS,GAS_CARD_TYPE,SERV_GAS_CARD_TYPE',
      });
      if (enumList && enumList.length) {
        this.searchBoxData.oilCardTypeOptions = this.$route.path.includes('gasCard') ? [
          { label: '全部', value: -1 },
          ...enumList[4],
        ] : [
          { label: '全部', value: -1 },
          ...enumList[0],
        ];
        this.searchBoxData.cardTypeOptions = this.$route.path.includes('gasCard') ? [
          {
            label: '全部',
            value: -1,
          },
          ...enumList[3],
        ] : [
          {
            label: '全部',
            value: -1,
          },
          ...enumList[1],
        ];
        this.searchBoxData.oilCardStatusOptions = [
          {
            label: '全部',
            value: -1,
          },
          ...enumList[2],
        ];
      }
    },
  },
  async created () {
    this.getEnumList();
    if (this.$route.path.includes('gasCard')) {
      this.searchBoxData.form.forEach((item) => {
        if (item.label.includes('油卡')) {
          item.label = item.label.replace(/油卡/g, '气卡');
        }
        if (item.placeholder && item.placeholder.includes('油卡')) {
          item.placeholder = item.placeholder.replace(/油卡/g, '气卡');
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
